import React from "react";

function BodiosContent() {
  const paragraphs = [
    {
      text: "BODIOS, a distinguished family-owned Mongolian brand with a heritage spanning 30 years, is now proudly led by its second generation. With privileged access to 60% of Mongolia's yak down, we meticulously oversee each step of production to achieve extraordinary softness—a true embodiment of luxury. By blending traditional craftsmanship with contemporary design, BODIOS creates timeless pieces that resonate with refined taste and uncompromising quality."
    },
    {
      text: "Our clientele extends from Switzerland and Europe to Asia, Japan, and beyond, reflecting the global allure of our exquisite yak down garments. Native to Mongolia's rugged, high-altitude terrain, the yak produces naturally sumptuous fibers that repel moisture and provide exceptional warmth. Scientific studies confirm that yak down is inherently warmer than Merino wool and cashmere, making it a truly rare and precious textile. Crafted into 100% natural, organic garments, each piece from BODIOS is a unique statement of purity and luxury."
    },
  ];

  return (
    <article className="font-libreFranklin font-light text-justify my-10 sm:my-16 md:my-20 px-4 sm:px-6 max-w-[1273px] w-full">
      <div className="space-y-6 sm:space-y-8">
        {paragraphs.map((paragraph, index) => (
          <p 
            key={index}
            className="text-sm sm:text-base md:text-lg leading-6 sm:leading-7 md:leading-8 text-gray-800"
          >
            {paragraph.text}
          </p>
        ))}
      </div>
    </article>
  );
}

export default BodiosContent;